module.exports = __webpack_public_path__ + "static/media/Jawa Standard.6bd8960b.png";